import { closeMultiUpload } from 'src/store/workspaces/modals/actions';
import { run as runActions } from '../../../../store/workspaces/workspaces/run';
import store from 'src/store/store';
import { log, toast } from 'src/utils/notification';

export const uploadAttachments = async (allAttachments, modalStates, workspaceActions) => {

  const fileNameElements = document.querySelectorAll('.e-upload-file-list');
  const visibleFileNames = Array.from(fileNameElements).map(el =>el.getAttribute('data-file-name'));
  const filtered = allAttachments.filter(file => visibleFileNames.includes(file.name));
  const eventKey = modalStates.multiUpload.widgetData?.events?.find((event) => event.type === 'onClick')?.key;

  if(filtered.length === 0){
    return runActions(eventKey, workspaceActions.id, { ...workspaceActions, upload: null });
  }

  for (const { name, fileSource, id: uuid, mime, fileSize } of filtered) {
    try {
      const response = await fetch(`${process.env.REACT_APP_URL}api/v1/file/upload${fileSource}`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify({
          url: fileSource,
          mimeType: mime,
          fileSize,
          data: { uuid }
        })
      });

      const result = await response.json();

      if(!result.success)
        return log( 'Upload Attachments', { message: result?.message, data: result?.data } , 'Error');

      runActions(eventKey, workspaceActions.id, { ...workspaceActions, upload: result.data });

      store.dispatch(closeMultiUpload({}));
    } catch (err) {
      log('Upload', `Fehler bei ${name}: ${err.message}`, 'Error');
      toast.error('Upload', err);
    }
  }
};